import "./Services.module.css";
import Header from "@/reusable_sections/Header";
import Engineering from "./sections/Engineering";
import Underwriting from "./sections/Underwriting";
import Insights from "./sections/Insights";
import Footer from "@/reusable_sections/Footer";
export default function ServicesPage() {
  return <div>
      <Header />
      <Engineering />
      <Underwriting />
      <Insights />
      <Footer />
    </div>;
}